import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import features from "./features.json";
import descriptions from "./description.json";
import {PaidFeatureUpgradeMode} from "../../paid-feature-upgrade.component";

interface Point {
  title: string;
  desc?: string;
  subPoints?: string[];
}

@Component({
    selector: 'db-paid-feature-upgrade-features',
    templateUrl: './paid-feature-upgrade-features.component.html',
    styleUrls: ['./paid-feature-upgrade-features.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PaidFeatureUpgradeFeaturesComponent implements OnInit {

  @Input() isAgency = false;
  @Input() mode: PaidFeatureUpgradeMode;
  @Output() onStepChange = new EventEmitter<'plans'>();
  public points: Point[] = [
    {
      title: 'Unlock all of 10Web',
      subPoints: []
    },
  ];
  description = '';

  constructor() { }

  ngOnInit() {
    this._getFeatures();
    this.description = descriptions[this.mode];
  }

  private _getFeatures(): void {
    if (this.isAgency) {
      this.points[0].subPoints = features['agency'];
        this.points.push({
        title: 'Get dedicated Slack Channel for VIP support',
        desc: 'Connect with our engineers and work with them directly to solve any issues as quickly as possible.'
      });
    }
    else {
      this.points[0].subPoints = features['smb'];
    }
  }


}
